import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';

import { store } from 'store/configureStore';

import Sentry from 'services/Sentry/SentryInstance';
import DatadogRUM from 'services/Datadog/DatadogRUM';
import { logger, ConsoleTransport } from '@user-portal/logger';

import reportWebVitals from './reportWebVitals';
import App from './App';

logger.addTransport(new ConsoleTransport());

Sentry.init();
DatadogRUM.init({
  sessionSampleRate: Number(import.meta.env.DD_RUM_SAMPLING_RATE) || 20,
  replaySampleRate: Number(import.meta.env.DD_SESSIONREPLAY_SAMPLING_RATE) || 0,
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

reportWebVitals(() => {});
